function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M684.973 207.146L442 453h668L867.027 207.146c-50.286-50.861-131.768-50.861-182.054 0z",
  fill: "#DF9D27"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M343.71 145.665L40 453h835L571.29 145.698c-62.854-63.592-164.726-63.592-227.58-.033z",
  fill: "#E8AF2A"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M266.247 71.76c-13.666 0-24.752 11.073-24.752 24.723v46.334h-39.893V30.711C201.602 13.75 187.836 0 170.854 0s-30.748 13.75-30.748 30.711v214.744h-41.6v-46.368c0-13.65-11.087-24.722-24.753-24.722S49 185.438 49 199.087v71.058c0 13.649 11.087 24.722 24.753 24.722h66.32V442h61.53V192.263h64.644c13.666 0 24.753-11.074 24.753-24.723V96.483c0-13.65-11.087-24.723-24.753-24.723z",
  fill: "#7FB241"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1440 506V361.6C959.985 295.01 480.015 481.247 0 421.323V506h1440z",
  fill: "#F3C432"
});

var _ref6 =
/*#__PURE__*/
React.createElement("g", {
  fill: "#7FB241"
}, React.createElement("path", {
  d: "M1075.25 246.926h-37.465c-5.376 0-9.717-4.348-9.717-9.732 0-5.383 4.34-9.73 9.717-9.73h27.748v-18.259c0-5.384 4.34-9.73 9.717-9.73 5.376 0 9.717 4.346 9.717 9.73v27.99c0 5.383-4.341 9.73-9.717 9.73zm-37.465 40.428h-38.133c-5.376 0-9.717-4.347-9.717-9.73v-27.99c0-5.384 4.34-9.73 9.717-9.73 5.376 0 9.717 4.346 9.717 9.73v18.258h28.416c5.376 0 9.717 4.348 9.717 9.731 0 5.384-4.341 9.731-9.717 9.731z",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M1049.872 379.983V183.29c0-6.688-5.409-12.105-12.087-12.105-6.679 0-12.088 5.417-12.088 12.105v196.66h24.175v.034z"
}));

var SvgDesertLandscape = function SvgDesertLandscape(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1440 506",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDesertLandscape, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/desert-landscape.c54e3093.svg";
export { ForwardRef as ReactComponent };